import React from 'react';
import SchemaViewerApp from '../../submodules/wrangler/apps/schema-viewer-app/src/App';
import '../../submodules/wrangler/apps/schema-viewer-app/src/App.css';
import '../../submodules/wrangler/apps/schema-viewer-app/src/index.css';
import { getAppLogoSrc } from '../../utils/appBranding';

function SchemaViewer() {
    // Standalone schema-viewer-app fetches /bdsa-schema.json. In this host app the
    // file is served from public/assets, and /bdsa-schema.json falls through to
    // index.html (JSON parse error: unexpected token '<!DOCTYPE').
    return (
        <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
            <SchemaViewerApp
                schemaFile="/assets/bdsa-schema.json"
                logoSrc={getAppLogoSrc()}
                showApiDocs={false}
            />
        </div>
    );
}

export default SchemaViewer;

